<template>
  <div>
    <div class="content-header"></div>

    <div class="content-wrapper">
      <el-row>
        <el-col :span="6" class="content-left">
          <div class="trade-container">
            <el-card class="trade-nav-panel">
              <div slot="header" class="clearfix">
                <span class="panel-header">渠道项目</span>
              </div>

              <el-menu router :default-active="$route.path">
                <el-menu-item index="/trade/index">
                  <span slot="title">渠道项目 首页</span>
                </el-menu-item>
                <el-menu-item index="/trade/order/all">
                  <span slot="title">查看所有订单</span>
                </el-menu-item>
                <el-menu-item index="/trade/order/waitApprove">
                  <span slot="title">待审批订单列表</span>
                </el-menu-item>
                <el-menu-item index="/trade/order/waitCheck" v-if="canApply || employeeLevel === 90">
                  <span slot="title">待验收订单列表</span>
                </el-menu-item>
                <el-menu-item index="/trade/order/waitAccept" v-if="canApply || employeeLevel === 90">
                  <span slot="title">待收货订单列表</span>
                </el-menu-item>
                <el-menu-item index="/trade/order/closed" v-if="canApply">
                  <span slot="title">已关闭订单列表</span>
                </el-menu-item>
                <el-menu-item index="/trade/apply" v-if="canApply">
                  <span slot="title">批量化物料提报</span>
                </el-menu-item>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="18" class="content-right" v-loading="loading">
          <trade-order-list
            ref="tradeOrderList"
            :orderList="orderList"
            :type="tradeType"
            @getApproveParams="getApproveParams"
            :queryParams="queryParams"
            @handleFilter="handleFilter"
          ></trade-order-list>
          <div class="pagination">
            <el-pagination
              v-if="orderList.length !== 0"
              background
              :total="total"
              layout="total, prev, pager, next"
              :current-page="queryParams.page"
              :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import tradeOrderList from './components/trade-order-list'
import { localStorageUtils } from '@/utils/localstorage'
import { mapGetters } from 'vuex'

export default {
  name: 'trade-order',
  components: {
    tradeOrderList
  },
  data () {
    return {
      exportParam: {
        quotaId: '',
        keyword: '',
        quotaStatus: '',
        leftAmount: '',
        rightAmount: '',
        effectiveDate: '',
        expireDate: ''
      },
      exportUrl: null,
      employeeLevel: '',

      loading: false,
      total: null,
      tradeType: '',

      orderList: [],

      queryParams: {
        page: 1,
        pageSize: 10,
        applyType: '',
        applyStatus: '',
        solutionStatus: '',
        acceptanceStatus: '',
        requirementStatus: '',
        executionStatus: '',
        isOwner: '',
        pledgePaid: '',
        applyClientLevel: '',
        queryType: '',
        queryRegionCode: '',
        queryBuCode: '',
        tradeStackWeek: '',
        tradeStackWeekStatus: '',
        waitClockIn: '',
        stackSpecs: '',
        applyNumber: '',
        vendorName: '',
        pocName: '',
        pocCode: '',
        execType: '',
        execTypeSub: '',
        isAll: '',
        keyword: '',
        orderCol: '',
        orderMethod: '',
        applyTypeTemp: '',
        applyStatusTemp: '',
        applySubStatusTemp: '',
        clientType: '',
        applyStatusList: '',
        waitSupplement: '',
        pocStatus: ''
      },

      defaultBuType: ''
    }
  },
  computed: {
    ...mapGetters(['userInfo']),

    // 是否可以提报批量化物料
    canApply () {
      return (
        this.employeeLevel === 45 ||
        this.employeeLevel === 50 ||
        this.employeeLevel === 60
      )
    }
  },
  created () {
    if (localStorageUtils.get('queryParams')) {
      this.queryParams = JSON.parse(localStorageUtils.get('queryParams'))
      this.$nextTick(() => {
        this.$refs.tradeOrderList.showStatus()
      })
      this.queryParams.page = 1
    }
    this.getRequest()
    this.employeeLevel = this.userInfo.employeeLevel
    this.defaultBuType = this.userInfo.defaultBuType
  },
  watch: {
    $route (to, from) {
      this.pageShow = false
      this.queryParams.page = 1
      this.queryParams.applyTypeTemp = ''
      this.queryParams.applyStatusTemp = ''
      this.queryParams.applySubStatusTemp = ''
      this.queryParams.applyStatus = ''
      this.queryParams.applyClientLevel = ''
      this.queryParams.queryBuCode = ''
      this.queryParams.queryRegionCode = ''
      this.queryParams.keyword = ''
      this.queryParams.applyType = ''
      this.queryParams.execTypeSub = ''
      this.queryParams.acceptanceStatus = ''
      this.queryParams.applyStatusList = ''
      this.queryParams.isAll = ''
      this.queryParams.solutionStatus = ''
      this.queryParams.requirementStatus = ''
      this.queryParams.executionStatus = ''
      this.queryParams.acceptanceStatus = ''
      this.queryParams.clientType = ''
      this.queryParams.queryType = ''
      this.queryParams.waitSupplement = ''
      this.getRequest()
    }
  },
  methods: {
    getRequest (val) {
      this.loading = true
      this.orderList = []
      this.tradeType = this.$route.params.tradeType
      if (this.tradeType === 'all' || this.tradeType === 'closed') {
        if (this.tradeType === 'closed') {
          this.queryParams.applyStatus = '900'
        }
        this.getAllList()
      }
      if (
        this.tradeType === 'waitApprove' ||
        this.tradeType === 'waitCheck' ||
        this.tradeType === 'waitAccept'
      ) {
        this.getApproveParams(this.tradeType)
      }
    },

    // 获取所有订单
    getAllList () {
      this.$store
        .dispatch('getAllList', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 设置审批列表所需参数
    getApproveParams (type) {
      // 待审批
      if (type === 'waitApprove') {
        this.queryParams.applyStatusList = '100,200'
        this.queryParams.isAll = '0'
      } else if (type === 'waitCheck') {
        this.queryParams.applyStatus = '400'
        this.queryParams.acceptanceStatus = '420'
        this.queryParams.isAll = '0'
      } else if (type === 'waitAccept') {
        this.queryParams.applyStatus = '400'
        this.queryParams.acceptanceStatus = '450'
        this.queryParams.isAll = '0'
      }
      this.getApproveList()
    },

    /** 获取审批订单 */
    getApproveList () {
      if(this.queryParams.applyStatus==='cooler-track'){
        this.queryParams.applyStatus='100'
        this.queryParams.execTypeSubList='111,112,113'
      }
      this.$store
        .dispatch('getApproveList', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts

            if (this.orderList.length) {
              this.orderList.forEach((item) => {
                this.$set(item, 'checked', false)
              })
            }
            this.$refs.tradeOrderList.showCheckBox('tradeOrder')
          }
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },

    handleCurrentChange (val) {
      this.queryParams.page = val
      this.loading = true
      if (this.tradeType === 'all' || this.tradeType === 'closed') {
        this.getAllList()
      } else if (
        this.tradeType === 'waitApprove' ||
        this.tradeType === 'waitCheck' ||
        this.tradeType === 'waitAccept'
      ) {
        this.getApproveList()
      }
    },

    // 筛选
    handleFilter () {
      this.queryParams.applyType = ''
      this.queryParams.execTypeSub = ''
      this.queryParams.solutionStatus = ''
      this.queryParams.requirementStatus = ''
      this.queryParams.executionStatus = ''
      this.queryParams.acceptanceStatus = ''
      this.queryParams.waitSupplement = ''
      this.queryParams.sievingDisablePoc = ''

      if (this.queryParams.applyStatusTemp === '210') {
        this.queryParams.solutionStatus = '210'
        this.queryParams.applyStatus = ''
      } else {
        this.queryParams.applyStatus = this.queryParams.applyStatusTemp
      }
      if (this.queryParams.applyTypeTemp === '02') {
        this.queryParams.applyType = this.queryParams.applyTypeTemp
      } else {
        this.queryParams.execTypeSub = this.queryParams.applyTypeTemp
      }

      if (this.queryParams.applyStatusTemp === '100') {
        this.queryParams.requirementStatus =
          this.queryParams.applySubStatusTemp
      } else if (this.queryParams.applyStatusTemp === '200') {
        this.queryParams.solutionStatus = this.queryParams.applySubStatusTemp
      } else if (this.queryParams.applyStatusTemp === '300') {
        this.queryParams.executionStatus = this.queryParams.applySubStatusTemp
      } else if (this.queryParams.applyStatusTemp === '400') {
        if (this.queryParams.applySubStatusTemp === '410') {
          this.queryParams.waitSupplement = '1'
        } else {
          this.queryParams.acceptanceStatus =
            this.queryParams.applySubStatusTemp
        }
      }

      this.getRequest('filter')
      localStorageUtils.remove('queryParams')
    }
  },

  beforeRouteLeave (to, from, next) {
    if (['trade-order-info', 'perfect-order-info', 'dcof-order-info', 'cooler-order-info'].includes(to.name)) {
      localStorageUtils.set('queryParams', JSON.stringify(this.queryParams))
    } else {
      localStorageUtils.remove('queryParams')
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.trade-nav-panel {
  width: 80%;
  min-height: 400px;
  margin: 0 auto;
  background: $base-white;
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
</style>
<style>
.pagination .el-pagination {
  text-align: center;
}
</style>
